import React, { useEffect, useRef, useState } from "react";
import RightToolbar from "./../components/RightToolbar";
import Sidebar from "./../components/Sidebar";
import { mailMessages4, incomingMails4 } from "./../utils/mails4";

function Mail4() {
  const [chechedAll, setCheckedAll] = useState(false);
  const [mails, setMails] = useState([]);
  const [previewId, setPreviewId] = useState(null);
  const [showReply, setShowReply] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replies, setReplies] = useState({});

  const replyRef = useRef(null);
  const nextIndexRef = useRef(0);

  const formatNow = () =>
    new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

  useEffect(() => {
    setMails(
      mailMessages4.map((mail, index) => ({
        ...mail,
        id: index + 1,
        cheched: false,
      }))
    );
  }, []);

  useEffect(() => {
    if (showReply) replyRef.current?.focus();
  }, [showReply]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Enter") return;
      if (previewId !== null) return;
      const idx = nextIndexRef.current;
      if (idx >= incomingMails4.length) return;

      e.preventDefault();
      const template = incomingMails4[idx];

      setMails((prev) => {
        const maxId = prev.reduce((m, x) => Math.max(m, x.id), 0);
        return [
          {
            id: maxId + 1,
            title: template.title,
            snippet: template.snippet,
            time: template.time,
            cheched: false,
            isNew: true,
          },
          ...prev,
        ];
      });

      nextIndexRef.current = idx + 1;
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [previewId]);

  const handleSend = (id) => {
    if (!replyText.trim()) return;
    setReplies((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), { text: replyText, time: formatNow() }],
    }));
    setReplyText("");
    setShowReply(false);
  };

  const checkAllMails = () => {
    setCheckedAll((prev) => !prev);
    setMails((curr) => curr.map((mail) => ({ ...mail, cheched: !chechedAll })));
  };

  const checkMail = (id) => {
    setMails((curr) =>
      curr.map((mail) => ({
        ...mail,
        cheched: mail.id === id ? !mail.cheched : mail.cheched,
      }))
    );
  };

  const deleteCheckedMails = () => {
    setCheckedAll(false);
    setMails((curr) => curr.filter((mail) => !mail.cheched));
  };

  const isAnyMailChecked = () => mails.some((mail) => mail.cheched);

  const deleteMail = (id) => {
    setPreviewId(null);
    setShowReply(false);
    setReplyText("");
    setMails((curr) => curr.filter((mail) => mail.id !== id));
  };

  const selected = previewId !== null ? mails.find((m) => m.id === previewId) : null;

  const renderMail = () => {
    if (!selected) return null;
    return (
      <div className="render-mail">
        <span
          className="material-symbols-outlined mail-pointer"
          onClick={() => { setPreviewId(null); setShowReply(false); setReplyText(""); }}
        >
          arrow_back
        </span>
        <span
          className="material-symbols-outlined delete mail-pointer"
          onClick={() => deleteMail(selected.id)}
        >
          delete
        </span>
        <span
          className="material-symbols-outlined mail-pointer"
          onClick={() => setShowReply((s) => !s)}
        >
          reply
        </span>

        <h1>{selected.title}</h1>
        <p>{selected.snippet}</p>

        {replies[selected.id] && (
          <div className="replies">
            {replies[selected.id].map((r, i) => (
              <div key={i} className="reply-msg">
                <div className="reply-author">You:</div>
                <div className="reply-text">{r.text}</div>
              </div>
            ))}
          </div>
        )}

        {showReply && (
          <div className="reply-box">
            <textarea
              ref={replyRef}
              className="reply-textarea"
              placeholder="Write your reply…"
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              rows={5}
            />
            <div className="reply-actions">
              <button
                className="btn send"
                onClick={() => handleSend(selected.id)}
                disabled={!replyText.trim()}
              >
                Send
              </button>
              <button
                className="btn cancel"
                onClick={() => { setShowReply(false); setReplyText(""); }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="page-mail-bg">
      <div className="mail-window">
        <div className="mail-window-header">
          <div className="mail-header-left">
            <div className="mail-search-box">
              <span className="material-icons-outlined">search</span>
              <input type="text" placeholder="Search mail" />
            </div>
            <div className="mail-title">Mail</div>
          </div>

          <div className="mail-header-right">
            <span className="material-icons-outlined">menu</span>
            <span className="material-icons-outlined">star</span>
            <div className="mail-profile"></div>
          </div>
        </div>

        <div className="mail-window-body">
          <Sidebar />

          <main className="mail-main-panel">
            {selected ? (
              <div className="mail-preview-mail">{renderMail()}</div>
            ) : (
              <>
                <div className="mail-data">
                  <span
                    className="material-symbols-outlined mail-pointer"
                    onClick={() => (mails.length ? checkAllMails() : {})}
                  >
                    {chechedAll ? "check_box" : "check_box_outline_blank"}
                  </span>

                  {isAnyMailChecked() && (
                    <span
                      className="material-symbols-outlined mail-pointer"
                      onClick={deleteCheckedMails}
                    >
                      delete
                    </span>
                  )}

                  <span className="material-symbols-outlined">more_horiz</span>
                  <div className="mail-count">
                    1 - {mails.length} of {mails.length}
                    <span className="material-symbols-outlined">
                      keyboard_arrow_left
                    </span>
                    <span className="material-symbols-outlined">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>

                <div className="mail-tabs-row">
                  <span className="material-icons-outlined mail-icon">inbox</span>
                  Primary
                  <span className="material-icons-outlined mail-icon">person</span>
                  Social
                  <span className="material-icons-outlined mail-icon">sell</span>
                  Promotions
                </div>

                <div className="mail-messages-list">
                  {mails.map((mail) => (
                    <div
                      className={`mail-msg-row ${mail.isNew ? "new-mail" : ""}`}
                      key={mail.id}
                    >
                      <span
                        className="material-symbols-outlined mail-pointer"
                        onClick={() => checkMail(mail.id)}
                      >
                        {mail.cheched ? "check_box" : "check_box_outline_blank"}
                      </span>
                      <div className="mail-star">
                        <span className="material-icons-outlined">star_outline</span>
                      </div>
                      <div
                        className="mail-snippet mail-pointer"
                        onClick={() => setPreviewId(mail.id)}
                      >
                        {mail.title}
                      </div>
                      <div
                        className="mail-snippet mail-pointer"
                        onClick={() => setPreviewId(mail.id)}
                      >
                        {mail.snippet}
                      </div>
                      <div className="time">{mail.time}</div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </main>

          <RightToolbar />
        </div>
      </div>
    </div>
  );
}

export default Mail4;
